<template>
  <div class="timeline-section">
    <div class="box">
      <h4 class="title is-4 mb-4">
        <i class="fa fa-clock-o mr-2"></i>
        {{ $t("evaluation timeline") }}
      </h4>

      <div class="timeline">
        <!-- Evaluation Created -->
        <TimelineItem
          :date="formatDate(evaluation.create_date)"
          :title="$t('evaluation created')"
          :description="$t('initial evaluation record created')"
          icon="fa-plus"
          type="info"
        />

        <!-- PDF Uploaded -->
        <TimelineItem
          v-if="evaluation.pdf_file_path"
          :title="$t('pdf uploaded')"
          :description="$t('evaluation document uploaded')"
          icon="fa-upload"
          type="warning"
        />

        <!-- Evaluation Completed -->
        <TimelineItem
          v-if="evaluation.status === 'completed'"
          :title="$t('evaluation completed')"
          :description="getCompletedDescription"
          icon="fa-check"
          type="success"
        />

        <!-- Evaluation Archived -->
        <TimelineItem
          v-if="evaluation.status === 'archived'"
          :title="$t('evaluation archived')"
          :description="$t('evaluation has been archived')"
          icon="fa-archive"
          type="dark"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TimelineItem from "./TimelineItem.vue";

export default {
  name: "TimelineSection",

  components: {
    TimelineItem,
  },

  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /**
     * Get description for completed evaluation
     */
    getCompletedDescription() {
      const result = this.evaluation.final_result;
      if (result) {
        return `${this.$t("final result")}: ${this.$t(result)}`;
      }
      return this.$t("evaluation processing completed");
    },
  },

  methods: {
    /**
     * Format date using moment
     */
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
.timeline-section {
  margin-bottom: 1.5rem;
}

.title {
  color: hsl(0, 0%, 96%) !important;
}

.timeline {
  position: relative;
  padding-left: 2rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}
</style>
